<template>
  <div class='parameter-group'>
      <info-item :name="title" value="Value" title nomarker noline/>
      <info-item
         v-for="({label,value}, index) in infos"
         :key="`vv-${index}`"
         :name="label"
         :value="value"
         noline
         nomarker
      />
   </div>
</template>

<script>
import InfoItem from '../../../molecules/Home/InfoItem';

export default {
   name: 'parameter-group',
   components: {
      InfoItem
   },
   props: {
      title: {
         type: String,
         required: true,
      },
      infos: {
         type: Array,
         required: true,
      },
   }
}
</script>

<style lang="scss" scoped>
.parameter-group {
   &:not(:first-child) {
      border-top: solid 1px rgba($primary-color, 0.2);
   }
}
</style>
